import { useCallback } from "react";
import PropTypes from "prop-types";
import { mapValues } from "lodash-es";
// eslint-disable-next-line no-restricted-imports
import { Route as ReactRouterRoute } from "react-router-dom";
import { currentRouteMatch } from "../../routes/routeMatch";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

const Route = ({
    component = undefined,
    render = undefined,
    globalFilters = undefined,
    suppressLocationKeyRemount = false,
    ...props
}) => {
    if (component) {
        const Component = component;
        render = p => <Component {...p} {...props} />;
    }
    // TODO Remove this workaround when upgrading to react-router@6
    //  react-route<6 have a bug that causes "/user/:id" route with "/user/123?a=b&c=d#section" to
    //  have match.params={ id: "123?a=b&c=d#section" }, instead of match.params=: { id: "123" }
    //  this is caused by a bug in react-route<6's dependency called path-to-regexp@0.1.7
    // TODO "/route/:id" with URL "/route/hello%20a%2Fb" translates to
    //  params: { id: "hello a%2Fb" } instead of { id: "hello a/b" },
    //  Can upgrading react-router(-dom) fix this? If so, remove this workaround
    const fixParamsParsingBug = useCallback(oldProps => {
        if (!oldProps.match.params) return oldProps;
        const match = { ...oldProps.match };
        if (match.params) {
            match.params = mapValues(match.params, value => decodeURIComponent(/^[^/#?]+/.exec(value)[0]));
        }
        return { ...oldProps, match };
    }, []);

    return (
        <ReactRouterRoute
            {...props}
            render={routeInjectedProps => {
                currentRouteMatch.setState(routeInjectedProps.match);

                return (
                    <ErrorBoundary key={props.path} section={`route:${props.path}`}>
                        {render({
                            ...fixParamsParsingBug(routeInjectedProps),
                            key: routeKey(routeInjectedProps.location, globalFilters, {
                                suppressLocationKeyRemount,
                            }),
                        })}
                    </ErrorBoundary>
                );
            }}
        />
    );
};

Route.propTypes = {
    exact: PropTypes.bool,
    path: PropTypes.string,
    render: PropTypes.func,
    component: PropTypes.any,
    suppressLocationKeyRemount: PropTypes.bool,
    globalFilters: PropTypes.object,
};

// Change route key and rerender the whole page when:
// - location changes
function routeKey(location, globalFilters, { suppressLocationKeyRemount = false }) {
    const keyParts = [!suppressLocationKeyRemount && location.key, JSON.stringify(globalFilters)]
        .filter(Boolean)
        .join(",");
    return keyParts || undefined;
}

export default Route;
